<template>
  <DsPopover
    :show="show"
    :placement="placement"
    :no-arrow="noArrow"
    @click-outside="isOpen = false"
  >
    <div
      ref="content"
      class="tooltip-content"
      @click="handleClick"
      @keydown.enter="handleClick"
    >
      <slot />
    </div>

    <template #content>
      <div>
        <slot name="tooltip" />
      </div>
    </template>
  </DsPopover>
</template>

<script lang="ts" setup>
import { DsPopover } from '@demvsystems/design-components';
import { useElementHover } from '@vueuse/core';
import type { Ref } from 'vue';
import { computed, ref } from 'vue';
import type { BasePlacement } from '@popperjs/core';

interface Props {
  clickable?: boolean;
  noArrow?: boolean;
  noHover?: boolean;
  placement?: BasePlacement;
}

const props = withDefaults(defineProps<Props>(), {
  clickable: false,
  noArrow: true,
  noHover: false,
  placement: undefined,
});

const content = ref<HTMLDivElement>();
const isOpen = ref(false);
let isHovered: Ref<boolean>;

if (props.noHover) {
  isHovered = ref(false);
} else {
  isHovered = useElementHover(content);
}

const show = computed(() => isHovered.value || isOpen.value);

const handleClick = (): void => {
  if (props.clickable) {
    isOpen.value = !isOpen.value;
  }
};
</script>
